/**
 * Auth Service - Integrates with MSAL for Entra ID authentication
 * 
 * This service provides utility functions for authentication management.
 * The primary authentication flow uses MSAL through the useMsal hook.
 */

/**
 * Set auth token in localStorage
 * Used by API interceptor to attach bearer token to requests
 */
export function setToken(token: string): void {
  localStorage.setItem('authToken', token);
}

/**
 * Get auth token from localStorage
 */
export function getToken(): string | null {
  return localStorage.getItem('authToken');
}

/**
 * Clear auth token from localStorage
 */
export function clearToken(): void {
  localStorage.removeItem('authToken');
}

/**
 * Check if user is authenticated
 * With MSAL, check via useMsal hook instead
 */
export function isAuthenticated(): boolean {
  return !!getToken();
}